import { render, staticRenderFns } from "./osagoResults.vue?vue&type=template&id=948b6cb2&"
import script from "./osagoResults.vue?vue&type=script&lang=js&"
export * from "./osagoResults.vue?vue&type=script&lang=js&"
import style0 from "./osagoResults.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports